/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
 window.onscroll = function() {
 var logo = document.getElementById("logo-image")
 if (window.pageYOffset > 50 || document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    logo.style.width = "60px";
    logo.style.transition = "0.2s ease";
 	} else {
    		logo.style.width = "120px";
    		logo.style.transition = '0.2s ease';
    		}
 }

 

 let ingredients = [   
   {
     civilization: [ ],
     name : "Rhassoul clay",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/RHASSOUL_CLAY_2.jpg?9014"
   },
   {
     civilization: ['africanNileCivilization', 'africanSavannahCivilization','carribeanCivilization','egyptianCivilization','indianMalabarCivilization','indusValleyIndoPakCivilization','maoriCivilization','mayanCivilization','romanCivilization','spanishCivilization', 'indusValleyKashmirCivilization'],
     name : "Shea butter",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SHEA_BUTTER.jpg?9014"
   }, 
   {
     civilization: ['africanNileCivilization','amazonCivilization','frenchCivilization','indianMalabarCivilization','indusValleyIndoPakCivilization','maoriCivilization','minoanCivilization','nativeAmericanCivilization'],
     name : "Argan oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ARGAN_OIL.jpg?9017"
   }, 
   {
     civilization: ['frenchCivilization','africanNileCivilization','indianHimalayanCivilization'],
     name : "Coconut milk",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/COCUNUT_MILK_2.jpg?9020"
   },    
   {
     civilization: ['frenchCivilization','africanNileCivilization'],
     name : "Reetha",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/REETHA.jpg?9020"
   },  
   {
     civilization: ['africanNileCivilization', 'frenchCivilization','indianHimalayanCivilization','indusValleyIndoPakCivilization','moroccanCivilization'],
     name : "Amla",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/AMLA.jpg?9020"
   }, 
   {
     civilization: ['africanNileCivilization', 'frenchCivilization','indianHimalayanCivilization','moroccanCivilization'],
     name : "Bhringraj",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BRINGARAJ.jpg?9020"
   }, 
   {
     civilization: ['africanNileCivilization', 'amazonCivilization','frenchCivilization','minoanCivilization'],
     name : "Shikakai",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SHIKAKAI.jpg?9023"
   }, 
   {
     civilization: ['frenchCivilization'],
     name : "Bentonite clay",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BENTONITE_CLAY.jpg?9023"
   },    
   {
     civilization: ['africanNileCivilization','indianHimalayanCivilization','indusValleyKashmirCivilization','mayanCivilization'],
     name : "Cocoa butter",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/COCOA_BUTTER.jpg?9023"
   }, 
   {
     civilization: ['africanNileCivilization', 'romanCivilization','egyptianCivilization','indianHimalayanCivilization','indusValleyIndoPakCivilization','nativeAmericanCivilization','spanishCivilization'],
     name : "Almond oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ALMOND.jpg?9023"
   },  
   {
     civilization: ['spanishCivilization','romanCivilization','nativeAmericanCivilization','japaneseCivilization','indonesianCivilization','indianMalabarCivilization','indianHimalayanCivilization','chineseCivilization','africanNileCivilization', 'africanSenegalCivilization','amazonCivilization','carribeanCivilization','egyptianCivilization','egyptianNileCivilization','hawaiianCivilization', 'maoriCivilization', 'mayanCivilization', 'minoanCivilization','ottomanCivilization', 'swissCivilization'],
     name : "Aloe vera",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ALOEVERA.jpg?9026"
   }, 
   {
     civilization: ['africanNileCivilization', 'amazonCivilization'],
     name : "Wheat protein",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/WHEAT_PROTEIN.jpg?9026"
   }, 
   {
     civilization: ['africanNileCivilization', 'amazonCivilization','bundjalungCivilization','indianHimalayanCivilization','indianMalabarCivilization'],
     name : "Rosemary oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ROSEMARY_3.jpg?9026"
   }, 
   {
     civilization: ['africanNileCivilization','amazonCivilization','minoanCivilization'],
     name : "Cedar wood oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CEDAR_WOOD.jpg?9026"
   }, 
   {
     civilization: [ 'hawaiianCivilization', 'indianMalabarCivilization', 'maoriCivilization', 'ottomanCivilization','romanCivilization'],
     name : "Baobab oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BAOBAB_OIL.jpg?9026"
   },    
   {
     civilization: ['africanSavannahCivilization','africanSenegalCivilization','chineseCivilization','egyptianNileCivilization','hawaiianCivilization','indianHimalayanCivilization', 'indianMalabarCivilization', 'indonesianCivilization','indusValleyIndoPakCivilization','indusValleyKashmirCivilization','minoanCivilization','moroccanCivilization','spanishCivilization', 'swissCivilization'],
     name : "Licorice",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/LICORICE_ROOT.jpg?9026"
   }, 
   {
     civilization: ['africanSavannahCivilization','indianHimalayanCivilization','japaneseCivilization'],
     name : "Lotus",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/PINK_LOTUS.jpg?9026"
   }, 
   {
     civilization:['africanSavannahCivilization','romanCivilization'],
     name : "Sea weed",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SEA_WEED.jpg?9026"
   }, 
   {
     civilization: ['africanSavannahCivilization','indianMalabarCivilization'],
     name : "Cucumber",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CUCUMBER.jpg?9029"
   }, 
   {
     civilization: ['africanSavannahCivilization','bundjalungCivilization','hawaiianCivilization','indusValleyIndoPakCivilization','romanCivilization','spanishCivilization'],
     name : "Mulberry",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/MULBERRY.jpg?9029"
   }, 
   {
     civilization: ['africanSavannahCivilization','chineseCivilization','romanCivilization','hawaiianCivilization','indianHimalayanCivilization','indusValleyIndoPakCivilization','japaneseCivilization','nativeAmericanCivilization', 'swissCivilization'],
     name : "Rose",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/INDIAN_ROSE.jpg?9029"
   }, 
   {
     civilization: ['africanSavannahCivilization','chineseCivilization','egyptianCivilization','indonesianCivilization','japaneseCivilization','minoanCivilization','moroccanCivilization','spanishCivilization'],
     name : "Ashwagandha",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ASHWAGANDHA.jpg?9029"
   }, 
   {
     civilization: ['romanCivilization','africanSavannahCivilization'],
     name : "Walnut shell",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/WALNUT_SHELL.jpg?9032"
   }, 
   {
     civilization: ['africanSavannahCivilization','spanishCivilization','hawaiianCivilization','indusValleyIndoPakCivilization','japaneseCivilization','moroccanCivilization', 'swissCivilization'],
     name : "Sandalwood oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SANDALWOOD.jpg?9032"
   }, 
   {
     civilization: ['africanSavannahCivilization'],
     name : "Cardamom oil ",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CARDAMOM_2.jpg?9032"
   }, 
   {
     civilization: ['africanSenegalCivilization','carribeanCivilization','egyptianCivilization','hawaiianCivilization','indianHimalayanCivilization','ottomanCivilization','spanishCivilization', 'indusValleyIndoPakCivilization','indusValleyKashmirCivilization', 'maoriCivilization','mayanCivilization'],
     name : "Kokum butter",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/KOKUM.jpg?9032"
   }, 
   {
     civilization: ['africanSenegalCivilization','carribeanCivilization','nativeAmericanCivilization'],
     name : "Avocado oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/AVOCADO.jpg?9032"
   }, 
   {
     civilization: ['africanSenegalCivilization','carribeanCivilization','egyptianCivilization','romanCivilization'],
     name : "Turmeric",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/TURMERIC.jpg?9032"
   }, {
     civilization: ['africanSenegalCivilization','egyptianCivilization', 'indianMalabarCivilization','indonesianCivilization','minoanCivilization'],
     name : "White tea",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/WHITE_TEA.jpg?9032"
   },  
   {
     civilization: ['egyptianCivilization','chineseCivilization','africanSenegalCivilization','indonesianCivilization','indianMalabarCivilization','nativeAmericanCivilization'],
     name : "Jasmine oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/JASMINE.jpg?9032"
   },
   {
     civilization: ['amazonCivilization','indianHimalayanCivilization','moroccanCivilization'],
     name : "Banyan tree",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BANYAN_TREE.jpg?9032"
   }, 
   {
     civilization:['indianHimalayanCivilization','minoanCivilization'],
     name : "Teatree oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/TEA_TREE_OIL.jpg?9032"
   }, 
   {
     civilization: ['bundjalungCivilization'],
     name : "Cinnamomum bark",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CINNAMON.jpg?9032"
   },
   {
     civilization: ['bundjalungCivilization','carribeanCivilization','ottomanCivilization'],
     name : "Neem",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/NEEM.jpg?9032"
   },    
   {
     civilization: ['bundjalungCivilization'],
     name : "Calendula",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CALENDULA.jpg?9032"
   },    
   {
     civilization: ['bundjalungCivilization','indonesianCivilization'],
     name : "Ginger",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GINGER.jpg?9032"
   }, 
   {
     civilization: ['bundjalungCivilization','egyptianCivilization','egyptianNileCivilization','indonesianCivilization','indusValleyIndoPakCivilization','indusValleyKashmirCivilization','minoanCivilization','romanCivilization','spanishCivilization'],
     name : "Honey",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/HONEY.jpg?9035"
   }, 
   {
     civilization: ['indianMalabarCivilization', 'maoriCivilization', 'ottomanCivilization'],
     name : "Mango butter",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/MANGO_BUTTER.jpg?9035"
   }, 
   {
     civilization: ['moroccanCivilization','carribeanCivilization','indusValleyIndoPakCivilization','indusValleyKashmirCivilization', 'spanishCivilization'],
     name : "Goat milk",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GOAT_MILK.jpg?9035"
   },
   {
     civilization: ['carribeanCivilization', 'maoriCivilization', 'moroccanCivilization'],
     name : "Saffron",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SAFFRON.jpg?9035"
   }, 
   {
     civilization:[],
     name : "Seabuckthorn",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SEABUCKTHORNE.jpg?9035"
   }, 
   {
     civilization: ['chineseCivilization','indianHimalayanCivilization','indusValleyIndoPakCivilization','moroccanCivilization', 'swissCivilization'],
     name : "Hyaluronic acid",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/HYALURONIC_ACID.jpg?9038"
   }, 
   {
     civilization: ['chineseCivilization','egyptianCivilization','indianMalabarCivilization'],
     name : "Green tea",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GREEN_TEA_2.jpg?9038"
   }, 
   {
     civilization: ['egyptianCivilization','indusValleyIndoPakCivilization','romanCivilization'],
     name : "Jojoba oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/JOJOBA_OIL.jpg?9042"
   },
   {
     civilization: ['egyptianCivilization'],
     name : "Coffee",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/COFFEE_BEANS.jpg?9042"
   },    
   {
     civilization:['egyptianCivilization'],
     name : "Vanilla",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/VANILLA.jpg?9042"
   },
   {
     civilization: ['egyptanNileCivilization'],
     name : "Activated Charcoal",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ACTIVATED_CHARCOAL.jpg?9042"
   }, 
   {
     civilization: ['egyptianCivilization','indianMalabarCivilization','ottomanCivilization'],
     name : "Oatmeal",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/OATS.jpg?9042"
   }, 
   {
     civilization: ['egyptianCivilization'],
     name : "Lemongrass oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/LEMON_GRASS.jpg?9042"
   }, 
   {
     civilization:['egyptianCivilization','indonesianCivilization','minoanCivilization','japaneseCivilization'],
     name : "Patchouli oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/PATCHOULI.jpg?9042"
   }, 
   {
     civilization: ['egyptianNileCivilization','indianHimalayanCivilization'],
     name : "Olive oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/OLIVE_OIL.jpg?9042"
   }, 
   {
     civilization: ['frenchCivilization','indianHimalayanCivilization','moroccanCivilization','romanCivilization'],
     name : "Brahmi",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BRAHMI.jpg?9042"
   },    
   {
     civilization: [],
     name : "Kukui nut oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/KUKUINUT.jpg?9042"
   }, 
   {
     civilization: ['indianHimalayanCivilization'],
     name : "Kusuma (Safflower)",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/KUSUMA_OIL.jpg?9042"
   }, 
   {
     civilization: ['indianHimalayanCivilization','swissCivilization'],
     name : "Vitamin C",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/VITAMIN_C.jpg?9042"
   }, 
   {
     civilization: ['indianHimalayanCivilization'],
     name : "Apple",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/APPLE.jpg?9042"
   }, 
   {
     civilization: ['indianHimalayanCivilization'],
     name : "Chenopodium Quinoa Seed",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/QUINOA_SEED.jpg?9042"
   }, 
   {
     civilization: ['indianHimalayanCivilization'],
     name : "Coconut oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/COCONUT_OIL.jpg?9042"
   }, 
   {
     civilization: ['mayanCivilization','indianHimalayanCivilization'],
     name : "Apricot oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/APRICOT.jpg?9042"
   }, 
   {
     civilization: ['moroccanCivilization','indianHimalayanCivilization'],
     name : "Baheda",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BAHEDA.jpg?9042"
   }, 
   {
     civilization: ['moroccanCivilization','indianHimalayanCivilization'],
     name : "Harad",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/HARAD.jpg?9045"
   }, 
   {
     civilization: ['indianHimalayanCivilization'],
     name : "Gotu kala",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GOTU_KALA.jpg?9045"
   }, 
   {
     civilization: ['moroccanCivilization','indianHimalayanCivilization'],
     name : "Hibiscus",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/HIBISCUS_2.jpg?9045"
   },    
   {
     civilization: ['indianHimalayanCivilization'],
     name : "Camphor",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CAMPHOR_OIL.jpg?9045"
   }, 
   {
     civilization: ['indianHimalayanCivilization', 'minoanCivilization'],
     name : "Clove oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CLOVES.jpg?9048"
   },    
   {
     civilization: [''],
     name : "Himalayan pink salt",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/HIMALAYAN_PINK_SALT.jpg?9048"
   }, 
   {
     civilization: ['indianHimalayanCivilization','indusValleyIndoPakCivilization'],
     name : "Manjishtha",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/MANJISTHA.jpg?9048"
   },    
   {
     civilization: ['indianMalabarCivilization', 'indonesianCivilization', 'minoanCivilization'],
     name : "Orange peel oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ORANGE_PEEL.jpg?9048"
   }, 
   {
     civilization: ['indianMalabarCivilization'],
     name : "Basil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BASIL.jpg?9048"
   }, 
   {
     civilization: ['indianMalabarCivilization', 'minoanCivilization','indonesianCivilization', 'minoanCivilization'],
     name : "Glycerin",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GLYCERINE.jpg?9048"
   }, 
   {
     civilization: ['indonesianCivilization'],
     name : "Mogra flower",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/MOGRA.jpg?9048"
   },   
   {
     civilization: [],
     name : "Yashada Dust",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/YASHADA_BHASMA.jpg?9048"
   }, 
   {
     civilization: [],
     name : "Cow ghee",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/COW_GHEE.jpg?9048"
   },    
   {
     civilization:[],
     name : "Squalane",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Lactic acid",
     asset_url : "https://via.placeholder.com/280x280.png?"
   },    
   {
     civilization: ['indusValleyIndoPakCivilization','moroccanCivilization','nativeAmericanCivilization'],
     name : "Red Sandalwood",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SANDALWOOD.jpg?9048"
   },    
   {
     civilization: ['indusValleyIndoPakCivilization','spanishCivilization','moroccanCivilization'],
     name : "Vetiver oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/VETIVER.jpg?9048"
   }, 
   {
     civilization: ['indusValleyIndoPakCivilization'],
     name : "Papaya",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/PAPAYA.jpg?9048"
   },    
   {
     civilization: ['indusValleyIndoPakCivilization'],
     name : "Pomegranate seeds",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/POMOGRANATE.jpg?9048"
   }, 
   
   {
     civilization: ['moroccanCivilization','indusValleyIndoPakCivilization'],
     name : "Nagkesar",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/NAGKESAR.jpg?9048"
   },    
   {
     civilization: ['indusValleyIndoPakCivilization','moroccanCivilization'],
     name : "Madder root",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/MADDER_ROOT.jpg?9048"
   },    
   {
     civilization: ['moroccanCivilization','indusValleyIndoPakCivilization'],
     name : "Nutgrass oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/NUT_GRASS.jpg?9048"
   },   
   {
     civilization: [],
     name : "Marine Algae",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/MARINE_ALGAE.jpg?9048"
   },    
   {
     civilization:['japaneseCivilization'],
     name : "Spirulina powder",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SPIRULINA.jpg?9048"
   },    
   {
     civilization: ['mayanCivilization'],
     name : "Frankincence oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/FRANKINCENSE.jpg?9048"
   }, 
   {
     civilization: ['mayanCivilization'],
     name : "Geranium oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GERANIUM.jpg?9048"
   },    
   {
     civilization: ['minoanCivilization'],
     name : "Green clay",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GREEN_CLAY.jpg?9048"
   },    
   {
     civilization: [],
     name : "Castor oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/CASTOR_OIL.jpg?9048"
   },   
   {
     civilization: ['minoanCivilization'],
     name : "Sesame oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SESAME_OIL.jpg?9048"
   },    
   {
     civilization: ['minoanCivilization'],
     name : "Rice scrub",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/RICE_SCRUB.jpg?9048"
   }, 
   {
     civilization: ['nativeAmericanCivilization'],
     name : "Horseleaf tail",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/HORSE_TAIL_WEED.jpg?9048"
   },    
   {
     civilization: ['romanCivilization','spanishCivilization'],
     name : "Ginkgo biloba",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/GINKO_BILOBA.jpg?9048"
   }, 
   {
     civilization: ['swissCivilization'],
     name : "Lime oil",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/LEMON_2.jpg?9048"
   },    
   {
     civilization:[],
     name : "Vitamin E",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Aqua",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Bael fruit",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Bees wax",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Beet root powder",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Benzyl Alcohol",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Brihati",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Brown tint",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Capryl Glucoside",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Carnauba wax",
     asset_url : "https://via.placeholder.com/280x280.png?"
   },  
   {
     civilization: [],
     name : "Cocamidopropyl betaine",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Coco glucoside",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "D Panthenol",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Daru haldi",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Decyl glucoside",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Diatomaceous earth",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Eucalyptus oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Figs",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Fullers Earth",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Gambhari",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Gel Base",
     asset_url : "https://via.placeholder.com/280x280.png?"
   },
   
   {
     civilization: [],
     name : "Gokshura",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Grapeseed oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Henna",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
  
   {
     civilization: [],
     name : "Hydrolyzed sesame protein",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SESAME.jpg?7547"
   }, 
   {
     civilization: [],
     name : "Isoamyl laurate",
     asset_url : "https://via.placeholder.com/280x280.png?"
   },
   {
     civilization: [],
     name : "Kantakari",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Kaolin clay",
     asset_url : "https://via.placeholder.com/280x280.png?"
   },
   {
     civilization: [],
     name : "Lauryl glucoside",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Lemon peel",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/LEMON.jpg?7547"
   }, 
   
   {
     civilization: [],
     name : "Magnesium ascorbyl phosphate(Vitamin C)",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/VITAMIN_C.jpg?7547"
   }, 
   {
     civilization: [],
     name : "Mahua",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Melon Oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Montmorillonite clay",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Nagchampa oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: ['indusValleyIndoPakCivilization'],
     name : "Neel kamal",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/BLUE_LOTUS.jpg?9048"
   }, 
   {
     civilization:[],
     name : "Neem leaves",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/NEEM.jpg?7547"
   }, 
   {
     civilization: [],
     name : "Padmaka",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Patala",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Pattanga",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Peppermint oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Polyquaternium-10",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization:[],
     name : "Potassium hydroxide",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization:[],
     name : "Potassium sorbate",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Prishnaparni",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Rapeseed Oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Rasberry seed oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Ricebran oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   },
   {
     civilization: [],
     name : "Rose petals",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/ROSE_PETALS.jpg?7547"
   }, 
   {
     civilization: [],
     name : "Saffron strings",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SAFFRON.jpg?7547"
   }, 
   {
     civilization:[],
     name : "Salicylic Acid",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Shalaparni",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Shyonaka",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Sodium benzoate",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Sodium hydroxide",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Sorbitol",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Soy protein",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Sucrose",
     asset_url : "https://cdn.shopify.com/s/files/1/0053/9774/1642/files/SUCROSE.jpg?7547"
   }, 
   {
     civilization:[],
     name : "Titanium di oxide",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Ushira",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Vanilla beans oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   },  
   {
     civilization: [],
     name : "Vat Vriksha",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization:[],
     name : "Wheatgerm oil",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }, 
   {
     civilization: [],
     name : "Zinc oxide",
     asset_url : "https://via.placeholder.com/280x280.png?"
   }
 ]
 function listIngredients(civilization) {
   return ingredients.filter(function(ingredient){
     return ingredient.civilization.indexOf(civilization) != -1;
   })
   
 }

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

window.setInterval(function(){
document.getElementById("demo").innerHTML = Math.floor((Math.random()*100)+1);
}, 10000);
 
